/**
 * Ce qu'on met dans le presse-papiers, et ce qu'on dit l'avoir mis.
 *
 * Demande de Nicolas du 05/10/2026 : au Secrétariat, le commentaire du
 * préleveur se recopie au clic, comme les champs du bloc « Identité (clic =
 * copie) ». Le texte part ENTIER, sauts de ligne compris : c'est une
 * ordonnance recopiée vers le SIL, pas un libellé d'un seul tenant.
 *
 * La règle est sortie ici pour être testable : `copyToClipboard` la portait
 * en son corps, mêlée au presse-papiers du navigateur, qu'on ne peut pas
 * éprouver en Node.
 */

/** Le texte à copier, ou "" quand il n'y a rien à copier. */
export function texteACopier(valeur) {
  return String(valeur ?? "").trim();
}

/** Ce qu'on annonce, une fois la copie faite. */
export function messageCopie(texte) {
  return "Copié : " + (texte.length > 60 ? texte.slice(0, 59) + "…" : texte);
}
